const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBtnScreenshotXs(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 1303",
    d: "M861.74 385.087a3.309 3.309 0 1 0 3.312 3.309 3.313 3.313 0 0 0-3.312-3.309zm0 4.619a1.309 1.309 0 1 1 1.31-1.31 1.312 1.312 0 0 1-1.308 1.31z",
    transform: "translate(-845.978 -373.012)",
    style: {
      fill: "current"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 1304",
    d: "M849.624 385.634h-2v3h3v-2h-1z",
    transform: "translate(-845.624 -372.996)",
    style: {
      fill: "current"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 1571",
    transform: "translate(2 7.453)",
    style: {
      fill: "current"
    },
    d: "M0 0h2v3.733H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 1305",
    d: "M847.624 378.967h2v-1h1v-2h-3z",
    transform: "translate(-845.624 -372.966)",
    style: {
      fill: "current"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 1572",
    transform: "translate(12.289 3)",
    style: {
      fill: "current"
    },
    d: "M0 0h3.916v2H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 1573",
    transform: "translate(6.699 3)",
    style: {
      fill: "current"
    },
    d: "M0 0h3.917v2H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 1306",
    d: "M864.957 378.967h2v-3h-3v2h1z",
    transform: "translate(-846.111 -372.966)",
    style: {
      fill: "current"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 1307",
    d: "M866.957 383.36v-2.926h-2v2.607l-.647-.968a1 1 0 0 0-.831-.443H860a1 1 0 0 0-.831.444l-.86 1.286h-1.785a2.161 2.161 0 0 0-2.157 2.154v1.12h-1.913v2h1.913v3.227a2.16 2.16 0 0 0 2.156 2.151h10.429a2.16 2.16 0 0 0 2.156-2.151v-6.35a2.161 2.161 0 0 0-2.151-2.151zm.154 8.5a.158.158 0 0 1-.158.156h-10.426a.157.157 0 0 1-.157-.154v-6.341a.158.158 0 0 1 .159-.157h2.317a1 1 0 0 0 .831-.444l.86-1.286h2.407l.862 1.287a1 1 0 0 0 .831.443h2.318a.156.156 0 0 1 .156.154z",
    transform: "translate(-846.111 -373.012)",
    style: {
      fill: "current"
    }
  }));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnScreenshotXs);
export default __webpack_public_path__ + "static/media/btn-screenshot-xs.99718c2f651ac9be405d6c310b03aa2b.svg";
export { ForwardRef as ReactComponent };